export default function(ctx) {
  const getters = ctx.store.getters
  if (!getters['auth/isLoggedIn']) {
    const err = new Error('Forbidden')
    err.response = { status: 403, data: {} }
    ctx.app.$error(err)
  }
}
